import { render, staticRenderFns } from "./Audiobooks.vue?vue&type=template&id=1cd8dfe7&scoped=true&"
import script from "./Audiobooks.vue?vue&type=script&lang=ts&"
export * from "./Audiobooks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd8dfe7",
  null
  
)

export default component.exports